const config = {
    apiUrl: process.env.REACT_APP_API_URL,
    apiUrlDirect: process.env.REACT_APP_API_URL_DIRECT,
    mapboxKey: process.env.REACT_APP_MAPBOX_KEY
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    ...config
}